export default __webpack_public_path__ + "e3273c41cfc844d682f66ed6b065feaa.png";